/* CloudSecurityParticipantTooltipV2.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"],
  _excluded3 = ["as", "style"],
  _excluded4 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _9 = "._18u0u2gc{margin-left:var(--ds-space-100,8px)}";
const _8 = "._19pkidpf{margin-top:0}";
const _7 = "._2lx2vrvc{flex-direction:row}";
const _6 = "._1e0c1txw{display:flex}";
const _5 = "._otyrpxbi{margin-bottom:var(--ds-space-200,1pc)}";
const _4 = "._19pkpxbi{margin-top:var(--ds-space-200,1pc)}";
const _3 = "._k48pni7l{font-weight:600}";
const _2 = "._1e0c1nu9{display:inline}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { BodySmall, LinkWithIcon } from '@atlassian/mpac-primitives';
import React from 'react';
import { TEST_IDS } from '../../primitives/testIds';
import CloudSecurityParticipantIcon from '../CloudSecurityParticipantIcon';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _ = "._p12f1tad{max-width:21.25rem}";
const Container = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_p12f1tad", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  Container.displayName = 'Container';
}
const BoldText = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_2, _3]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1nu9 _k48pni7l", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  BoldText.displayName = 'BoldText';
}
const DetailsContainer = forwardRef((_ref3, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref3,
    __cmplp = _objectWithoutProperties(_ref3, _excluded3);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_4, _5, _6, _7]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkpxbi _otyrpxbi _1e0c1txw _2lx2vrvc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  DetailsContainer.displayName = 'DetailsContainer';
}
const DetailsText = forwardRef((_ref4, __cmplr) => {
  let {
      as: C = BodySmall,
      style: __cmpls
    } = _ref4,
    __cmplp = _objectWithoutProperties(_ref4, _excluded4);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_8, _9]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_19pkidpf _18u0u2gc", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  DetailsText.displayName = 'DetailsText';
}
const CloudSecurityParticipantTooltipV2 = _ref5 => {
  let {
    learnMoreLink
  } = _ref5;
  return /*#__PURE__*/_jsxs(Container, {
    "data-testid": TEST_IDS.CLOUD_SECURITY_PARTICIPANT_TOOLTIP_V2,
    children: [/*#__PURE__*/_jsxs(BodySmall, {
      children: [/*#__PURE__*/_jsx(BoldText, {
        children: "Cloud Security Participant"
      }), " apps offer verified security through:"]
    }), /*#__PURE__*/_jsxs(DetailsContainer, {
      children: [/*#__PURE__*/_jsx(CloudSecurityParticipantIcon, {
        label: "",
        size: "medium",
        primaryColor: "var(--ds-icon, #44546F)",
        testId: "cloud-security-participant-icon"
      }), /*#__PURE__*/_jsx(DetailsText, {
        children: "Participation in the Marketplace Bug Bounty program"
      })]
    }), /*#__PURE__*/_jsx(LinkWithIcon, {
      href: learnMoreLink,
      type: "external",
      size: "small",
      children: "Know more about the Bug bounty program"
    })]
  });
};
export default CloudSecurityParticipantTooltipV2;